var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.1818H20.75H20ZM4 10.1818H3.25H4ZM12 2V2.75V2ZM19.25 10.1818C19.25 12.132 18.4145 14.0394 17.241 15.7472C16.0716 17.4492 14.6078 18.8927 13.4503 19.8994L14.4347 21.0312C15.6451 19.9785 17.21 18.4411 18.4773 16.5967C19.7407 14.758 20.75 12.5533 20.75 10.1818H19.25ZM10.5497 19.8994C9.39225 18.8927 7.92842 17.4492 6.75896 15.7472C5.58549 14.0394 4.75 12.132 4.75 10.1818H3.25C3.25 12.5533 4.25934 14.758 5.52267 16.5967C6.79 18.4411 8.35493 19.9785 9.56533 21.0312L10.5497 19.8994ZM4.75 10.1818C4.75 8.20541 5.51784 6.31324 6.8794 4.92074L5.80689 3.87206C4.16787 5.54833 3.25 7.81832 3.25 10.1818H4.75ZM6.8794 4.92074C8.2404 3.5288 10.0827 2.75 12 2.75V1.25C9.67385 1.25 7.44647 2.19522 5.80689 3.87206L6.8794 4.92074ZM12 2.75C13.9173 2.75 15.7596 3.5288 17.1206 4.92074L18.1931 3.87206C16.5535 2.19522 14.3262 1.25 12 1.25V2.75ZM17.1206 4.92074C18.4822 6.31325 19.25 8.20541 19.25 10.1818H20.75C20.75 7.81832 19.8321 5.54833 18.1931 3.87206L17.1206 4.92074ZM13.4503 19.8994C12.604 20.6355 11.396 20.6355 10.5497 19.8994L9.56533 21.0312C10.9761 22.2582 13.0239 22.2582 14.4347 21.0312L13.4503 19.8994Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/point.e87d1f0088fd7af6ff004bdf674b75f1.svg";
export { ForwardRef as ReactComponent };